import { createAction } from '@reduxjs/toolkit';
import type { ReadConversationsApiArg } from 'lib-shared-types-api';

const prefix = 'conversationsPage';

export const conversationsActions = {
  setLastSearchParams: createAction<{ apiArg: ReadConversationsApiArg }>(
    `${prefix}/setLastSearchParams`,
  ),
};
